export const CHANGE_EMPLOYEES_KEY = 'changeEmployees';
export const FINISH_TASKS_KEY = 'finishTasks';
export const DELETE_TASKS_KEY = 'deleteTasks';
export const TASK_PREVIEW_KEY = 'taskPreview';
export const TASK_HISTORY_KEY = 'taskHistory';
export const EDIT_TASK_KEY = 'editTask';
